/// <amd-module name="SuiteCommerce.ProductLeadTime.Utils"/>
define("SuiteCommerce.ProductLeadTime.Utils", ["require", "exports", "Utils"], function (require, exports, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Utils = void 0;
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.translate = function (string) {
            return Utils_1.translate(string);
        };
        Utils.getAbsoluteUrl = function (file, isServices2) {
            if (file === void 0) { file = ''; }
            if (isServices2 === void 0) { isServices2 = false; }
            return Utils_1.getAbsoluteUrl(file, isServices2);
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
